import i18next from 'i18next';

export const CATEGORY_FILTER_ICON = '/images/inpulse/category-ipblack-small.svg';
export const SUB_CATEGORY_FILTER_ICON = '/images/inpulse/sub-category-ip-black-small.svg';
export const CENTRAL_FILTER_ICON = '/images/inpulse/central-black-small.svg';

/**
 * Central-product filter options shared by the external-client product lists (works like the
 * ingredients strategic / non-strategic filter). Each option carries the `isKitchen` flag it maps to.
 */
export const getCentralProductFilterItems = () => [
  {
    id: 'central',
    value: i18next.t('EXTERNAL_CLIENTS.CREATION.MANUAL_FILTER_CENTRAL'),
    isKitchen: true,
  },
  {
    id: 'non-central',
    value: i18next.t('EXTERNAL_CLIENTS.CREATION.MANUAL_FILTER_NOT_CENTRAL'),
    isKitchen: false,
  },
];
